export default __webpack_public_path__ + "static/media/1867.44f5df5d.png";